import { Alert, Card, Col, Row, Statistic, Tag } from 'antd';
import { TeamOutlined, DatabaseOutlined, TableOutlined, PartitionOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAdminScope } from '../context/AdminScopeContext';
import { tenantService, schemaProfileService, workflowProfileService } from '../api/services';
import { loadSchemaGitSettings } from '../storage/schemaGitSettings';

export function HomePage() {
  const navigate = useNavigate();
  const { scope } = useAdminScope();
  const [tenantCount, setTenantCount] = useState<number | null>(null);
  const [profileCount, setProfileCount] = useState(0);
  const [workflowCount, setWorkflowCount] = useState(0);

  useEffect(() => {
    if (!scope?.canAccessDcAdmin) {
      return;
    }
    tenantService
      .listForScope(scope)
      .then((tenants) => setTenantCount(tenants.length))
      .catch(() => setTenantCount(null));

    if (scope.isPlatformAdmin) {
      const conn = loadSchemaGitSettings();
      schemaProfileService
        .list(conn)
        .then((result) => setProfileCount(result.ok ? result.profiles.length : 0))
        .catch(() => setProfileCount(0));
      workflowProfileService
        .list(conn)
        .then((result) => setWorkflowCount(result.ok ? result.profiles.length : 0))
        .catch(() => setWorkflowCount(0));
    }
  }, [scope]);

  if (!scope) {
    return null;
  }

  return (
    <div>
      {!scope.canAccessDcAdmin && (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 24 }}
          message="当前账号无管理权限"
          description="需要平台管理员身份，或由平台管理员指定为组织租户（ORGANIZATION）的管理员。个人租户（PERSONAL）自注册管理员不可进入本系统。"
        />
      )}

      {scope.canAccessDcAdmin && !scope.isPlatformAdmin && (
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 24 }}
          message="组织租户管理员"
          description={`您可管理 ${scope.managedTenantIds.length} 个组织租户的成员与 Schema 绑定，无法创建新租户或管理全局 Schema Profile。`}
        />
      )}

      <p style={{ marginBottom: 24, color: '#666' }}>
        平台管理员（Keycloak JWT）可管理全量租户与 Schema Profile；组织租户管理员（tenant_admins + ORGANIZATION）仅可管理被授权的组织租户。
      </p>

      {scope.canAccessDcAdmin && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={8}>
            <Card hoverable onClick={() => navigate('/tenants')}>
              <Statistic
                title={scope.isPlatformAdmin ? '租户（全平台）' : '我管理的租户'}
                value={tenantCount ?? 0}
                prefix={<TeamOutlined />}
              />
              {!scope.isPlatformAdmin && <Tag style={{ marginTop: 8 }}>组织租户管理员</Tag>}
            </Card>
          </Col>
          {scope.isPlatformAdmin && (
            <>
              <Col xs={24} sm={12} lg={8}>
                <Card hoverable onClick={() => navigate('/schema-profiles')}>
                  <Statistic title="Schema Profile" value={profileCount} prefix={<DatabaseOutlined />} />
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={8}>
                <Card hoverable onClick={() => navigate('/workflow-profiles')}>
                  <Statistic title="工作流定义" value={workflowCount} prefix={<PartitionOutlined />} />
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={8}>
                <Card hoverable onClick={() => navigate('/schema-indexes')}>
                  <Statistic title="索引管理" value="运维" prefix={<TableOutlined />} />
                </Card>
              </Col>
            </>
          )}
        </Row>
      )}
    </div>
  );
}
